import { render, staticRenderFns } from "./skeletonNewsDetail.vue?vue&type=template&id=07afb62a&scoped=true&lang=true&"
import script from "./skeletonNewsDetail.vue?vue&type=script&lang=js&"
export * from "./skeletonNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./skeletonNewsDetail.vue?vue&type=style&index=0&id=07afb62a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07afb62a",
  null
  
)

export default component.exports